export default {
  group: {
    itself: 'Group',
    plural: {
      itself: 'Groups',
    },
  },
};
